<div class="pt-4">
  <div class="flex align-items-center justify-content-between mb-4">
    <h2 class="text-2xl font-semibold m-0" data-clarity-unmask="true">Dodaj nowy dział wykładu</h2>
    <p-button
    [text]="true"
      icon="pi pi-times"
      [rounded]="true"
      (onClick)="closeDialog()"
      data-clarity-unmask="true"
    ></p-button>
  </div>

  <div
    *ngIf="loading"
    class="flex justify-content-center align-items-center p-4"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>

  <div *ngIf="!loading">
    <form [formGroup]="categoryForm">
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mt-4"
      >
        <div class="title">Pokaż dział w aplikacji</div>
        <p-inputSwitch
          id="isActive"
          formControlName="isActive"
        />
      </div>
      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Nazwa działu</div>
        <input
          id="categoryName"
          type="text"
          pInputText
          formControlName="name"
          placeholder="Nazwa działu"
        />
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Przypisane kategorie egzaminów</div>
        <p-multiSelect
          [appendTo]="'body'"
          id="categoryExams"
          formControlName="selectedExams"
          [options]="availableExams"
          optionLabel="examName"
          optionValue="guid"
          placeholder="Wybierz kategorie egzaminów"
          styleClass="custom-multiselect w-full"
          class="w-full"
          [showToggleAll]="false"
          [filter]="false"
          [maxSelectedLabels]="10"
        >
        </p-multiSelect>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Pozycja działu</div>
        <p-inputNumber
          id="categoryOrder"
          formControlName="order"
          placeholder="Pozycja"
          min="0"
          class="w-full"
          styleClass="w-full"
        />
      </div>

      <div formArrayName="translations">
        <div
          *ngFor="let translationForm of translations.controls; let i = index"
          [formGroupName]="i"
        >
          <div
            class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleTranslationCollapse(i)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-flag"></i>
              <div class="font-medium">
                Wersja językowa {{ i + 1 }}
                <span *ngIf="translationForm.get('languageCode')?.value">
                  -
                  {{
                    getLanguageName(translationForm.get("languageCode")?.value)
                  }}</span
                >
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isTranslationCollapsed(i) ? 'pi-chevron-down' : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isTranslationCollapsed(i)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wybierz język</div>
              <p-dropdown
                [options]="getAvailableLanguagesForTranslation(i)"
                optionLabel="name"
                optionValue="code"
                placeholder="Wybierz język"
                class="w-full"
                styleClass="w-full"
                formControlName="languageCode"
              >
              </p-dropdown>
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Nazwa</div>
              <input
                type="text"
                pInputText
                formControlName="name"
                placeholder="Nazwa działu"
              />
            </div>
            <div class="flex w-full justify-content-end form-decorator bottom-primary-decorator">
              <p-button
                label="Usuń tą wersję językową"
                icon="pi pi-trash"
                (onClick)="removeTranslationForm(i); $event.stopPropagation()"
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreTranslations()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="addNewTranslationForm()"
      >
        <div class="add-translation">Dodaj kolejną wersję językową</div>
        <i class="add-translation pi pi-plus"></i>
      </div>
    </form>
  </div>

  <div class="flex justify-content-end gap-3 pt-3">
    <p-button
      label="Anuluj"
      [outlined]="true"
      (onClick)="closeDialog()"
      data-clarity-unmask="true"
    ></p-button>
    <p-button
      label="Zapisz"
      icon="pi pi-check"
      (onClick)="saveCategory()"
      [disabled]="!canSaveCategory() || loading"
      [loading]="loading"
      data-clarity-unmask="true"
    ></p-button>
  </div>
</div>
